import { memo } from 'react';
import CreateEditChart from 'Modules/dashboard/views/.components/chart/.components/forms/createEditChart'
import CreateEditClipRequestByStatus from 'Modules/dashboard/views/.components/chart/.components/forms/createEditClipRequestByStatus';
import CreateEditVidFleetFirmware from 'Modules/dashboard/views/.components/chart/.components/forms/createEditVidFleetFirmware';
import CreateEditDeviceByStatus from 'Modules/dashboard/views/.components/chart/.components/forms/createEditDeviceByStatus';
import CreateEditLastReadings from 'Modules/dashboard/views/.components/chart/.components/forms/createEditLastReadings';
import MaintenanceWarnings from 'Modules/dashboard/views/.components/chart/.components/forms/createEditMaintenanceWarnings';
const renderComponent = (props) => {
    const { selectGadget, onSubmit, handleClose } = props;
    let type = {
        'Chart': <CreateEditChart onSubmit={onSubmit} handleClose={handleClose} />,
        'ClipRequestByStatus': <CreateEditClipRequestByStatus onSubmit={onSubmit} handleClose={handleClose} />,
        'VidFleetFirmware': <CreateEditVidFleetFirmware onSubmit={onSubmit} handleClose={handleClose} />,
        'DevicesByStatus': <CreateEditDeviceByStatus onSubmit={onSubmit} handleClose={handleClose} />,
        'UnitsThatStoppedReporting': <CreateEditLastReadings onSubmit={onSubmit} handleClose={handleClose} />,
        'MaintenanceWarnings': <MaintenanceWarnings onSubmit={onSubmit} handleClose={handleClose} />,
        'Default': <div>Default</div>
    };
    return type[selectGadget?.type] || type['Default']
};

const CreateEditView = (props) => {
    return (
        <>
            {renderComponent(props)}
        </>
    )
}

export default memo(CreateEditView)